// logs its argument and a given tag
export const log = ( tag ) => ( x ) => {
	console.log( tag, x ); // eslint-disable-line
	return x;
};

export const keys = ( o ) => Object.keys( o );

export const toPairs = ( o ) => Object.entries( o );
